<template>
	<div class="container">
		<div class="main_box">
			<div class="main_main">
				<div class="page_main">
					<div class="training-page">
						<el-form ref="form"
							:model="form"
							:rules="rules"
							label-position="top"
							class="training-form">
							<div class="info-block">
								<div class="info-item">
									<div class="info-label">
										Training Overview
									</div>
									<el-link type="primary" :underline="false">
										{{ name }}
									</el-link>
								</div>
								<div class="info-item">
									<div class="info-label">
										User
									</div>
									<el-link type="primary" :underline="false">
										<div v-for="value in list"
											:key="value.id"
											style="padding: 4px 0;">
											<span>
												{{ value.username + ' - ' + ' (' + value.departments_name + ')' }}
											</span>
										</div>
									</el-link>
								</div>
							</div>
							<!-- Form Items -->
							<el-form-item v-if="leixing == 'overview'"
								label="Is Certification Required?"
								prop="is_certification">
								<el-select v-model="form.is_certification"
									placeholder="Please select"
									class="full-width">
									<el-option label="Yes" :value="1"></el-option>
									<el-option label="No" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Required Training Due Date"
								prop="end_time">
								<el-date-picker
									v-model="form.end_time"
									type="date"
									placeholder="Please select"
									style="width: 100%">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="Allow Users to Complete Training Independently?"
								prop="is_assigned"
								class="select-item">
								<el-select v-model="form.is_assigned"
									placeholder="Please select"
									class="full-width">
									<el-option label="Yes" value="1"></el-option>
									<el-option label="No" value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item v-if="form.is_assigned == 1"
								label="Training Type"
								prop="train_leixing_id"
								class="select-item">
								<el-select v-model="form.train_leixing_id"
									placeholder="Please select"
									class="full-width">
									<el-option label="External Training" value="1"></el-option>
									<el-option label="Read and Understand Training" value="2"></el-option>
									<el-option label="Self Training" value="3"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item v-if="form.is_assigned == 1 && form.train_leixing_id"
								label="Does This Indicate the Requirement Has Been Met?"
								prop="is_meet"
								class="select-item">
								<el-select disabled
									v-model="form.is_meet"
									placeholder="Please select"
									class="full-width">
									<el-option label="Yes" :value="1"></el-option>
									<el-option label="No" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<div class="btn-group">
								<el-button type="primary"
									@click="handleSave">
						
									Save
						
								</el-button>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { trainRecordAddUser } from '@/api/trainManage/configTrain/trainRecord/index';
import { trainGerenalAddUser } from '@/api/trainManage/configTrain/generalTrain/index';
import moment from 'moment';
export default {
	name: "UserSelectDialog",
	props: {
		recordId: Number,
		recordName: String,
		type: String,
		userIds: {
			type: Array,
			default: () => [],
		},
		userRows: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isLoading: true,
			form: {
				is_certification: '',
				end_time: '',
				is_assigned: '',
				train_leixing_id: '',
				is_meet: 1
			},
			rules: {
				is_certification: [{ required: true, message: "Please select", trigger: "change" }],
				end_time: [{ required: true, message: "Please select", trigger: "change" }],
				is_assigned: [{ required: true, message: "Please select", trigger: "change" }],
				train_leixing_id:[{ required: true, message: "Please select", trigger: "change" }],
				is_meet: [{ required: true, message: "Please select", trigger: "change" }],
			},
			id: null,
			name: '',
			ids: null,
			list: [],
			leixing: ''
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		that.id = that.recordId;
		that.name = that.recordName;
		that.ids = that.userIds;
		that.list = that.userRows;
		that.leixing = that.type;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		handleSave() {
			let that = this;
			that.$refs.form.validate((valid) => {
				if(!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				if(that.leixing == 'overview') {
					//通用
					trainGerenalAddUser({
						uids: that.ids.join(','),
						gerenal_id: that.id,
						is_certification: that.form.is_certification,
						end_time: moment(that.form.end_time).valueOf() / 1000,
						is_assigned: that.form.is_assigned,
						train_leixing_id: that.form.is_assigned == 1 ? that.form.train_leixing_id : '',
						is_meet: that.form.is_assigned == 1 ? that.form.is_meet : ''
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$emit('update-data');
							}, 800);
						}
					});
				}else if(that.leixing == 'demand') {
					//档案
					trainRecordAddUser({
						uids: that.ids.join(','),
						record_id: that.id,
						end_time: moment(that.form.end_time).valueOf() / 1000,
						is_assigned: that.form.is_assigned,
						train_leixing_id: that.form.is_assigned == 1 ? that.form.train_leixing_id : '',
						is_meet: that.form.is_assigned == 1 ? that.form.is_meet : ''
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$emit('update-data');
							}, 800);
						}
					});
				}
			});
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
}
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-page {
  min-height: 100%;
  padding: 20px 18px 40px;
  box-sizing: border-box;
}

.training-form {
  width: 100%;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 18px;
}

.info-block {
  margin-bottom: 24px;
}

.info-item {
  margin-bottom: 18px;
}

.info-label {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  margin-bottom: 8px;
}

.select-item {
  margin-bottom: 32px;
}

.full-width {
  width: 100%;
}

.btn-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
}

/* 调整 Element 默认样式，更接近截图 */
::v-deep .el-form-item__label {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 8px;
}

::v-deep .el-select .el-input__inner {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
}

::v-deep .el-button {
  min-width: 68px;
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

